export default "/assets/images/app-showcase-03-sm.jpg?76665c022bb42709fcc075a091584152";